import { useEffect } from 'react';
import identifyBloomreach from './bloomreach';

/** Identifies the customer to Bloomreach whenever their email is known (it only exists once logged in). */
const useBloomreachIdentify = (email?: string | null): void => {
  useEffect(() => {
    identifyBloomreach(email);
  }, [email]);
};

export default useBloomreachIdentify;
